import { QueryClient } from "@tanstack/react-query";

import { BidQuery } from "../../../../generated/app-service-gql/graphql";

/**
 * Updates the bid query cache for a given bid ID
 */
export function updateBidQuery(
  queryClient: QueryClient,
  bidId: string,
  updater: (bid: BidQuery["bid"]) => BidQuery["bid"],
) {
  const key = ["bid", bidId];
  queryClient.setQueryData<BidQuery>(key, (prev) => {
    if (!prev) return prev;
    return { bid: updater(prev.bid) };
  });
}
